import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import registerServiceWorker from './registerServiceWorker';

/**
 * Offers the new version rather than applying it underneath the visitor.
 *
 * A service worker that reloads on its own takes the page away mid-sentence -
 * mid-hand, if someone is at a table. This asks, and stays out of the way if
 * the answer is no: the update installs on its own the next time the app is
 * opened cold.
 */
export default function UpdateToast() {
  const { t } = useTranslation();
  const [activate, setActivate] = useState(null);

  useEffect(() => {
    // Stored as a function inside a function: passing a bare function to a
    // state setter would call it instead of storing it.
    registerServiceWorker((run) => setActivate(() => run));
  }, []);

  if (!activate) return null;

  return (
    <div className="update-toast" role="status">
      <span>{t('pwa.updateReady', 'نسخه تازه‌ای آماده است.')}</span>
      <button type="button" className="btn btn-primary btn-sm" onClick={activate}>
        {t('pwa.refresh', 'به‌روزرسانی')}
      </button>
      <button
        type="button"
        className="btn btn-ghost btn-sm"
        onClick={() => setActivate(null)}
        aria-label={t('pwa.dismiss', 'بستن')}
      >
        ✕
      </button>
    </div>
  );
}
